import React from 'react';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';

import formatter from '../../../common/helpers/formatter';
import socialMediaForm from '../../../documentation/fbForm/forms/socialMediaForm';
import type { DocumentationStatistic } from '../../../common/types/statistics/fbStatistics';

type Props = {
  statistics: DocumentationStatistic;
};

function SocialMediaStatistics({ statistics }: Props) {
  const { socialMedia } = statistics;

  const socialMeddiaOptions = formatter.getFieldSelectOptions('socialMedia', socialMediaForm.fields);

  return (
    <Stack direction='column'>
      <Typography component='h3' variant='h6' fontWeight='bold'>
        Social Media
      </Typography>
      {Object.keys(socialMedia).map((key) => (
        <Stack key={key} spacing={1}>
          <Typography fontWeight='bold'>{formatter.getOptionLabel(socialMeddiaOptions, key)}</Typography>
          <Typography>Anzahl der Follower: {socialMedia[key].numberOfFollowers}</Typography>
          <Typography>Anzahl der Posts: {socialMedia[key].numberOfPosts}</Typography>
        </Stack>
      ))}
    </Stack>
  );
}

export default SocialMediaStatistics;
